import { ReactNode } from 'react';
import { MenuModel } from '../../../models';

export type headerTabDataTableLayoutPreRendered = { [hash: string]: Array<ReactNode> };

export class HeaderTabDataModel {
  readonly id: string;

  readonly menu: MenuModel;

  constructor(id: string, menu: MenuModel) {
    this.id = id;
    this.menu = menu;
  }
}
